import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Form, Space, Popover, DatePicker, Input } from 'antd';
import { FileTextFilled } from '@ant-design/icons';
import TSTable from '../../components/common/TSTable';
import MainHeader, { MENU_INTERFACE_AX } from '../../components/common/MainHeader';
import { URL_INTERFACE_AX } from '../../constance/urls';
import { POST } from '../../utils/HttpClient';
import { ellipsisString } from '../../utils/stringFormat';
import { Toast } from '../../utils/Toast';
import * as _ from 'lodash'
import InterfaceAXTransactionModal from '../../components/interface-ax/InterfaceAXTransactionModal';
import Title from 'antd/es/typography/Title';
import { DATE_FORMAT, HUMAN_DATE_FORMAT } from "../../constance/strings"
import { useDebounce } from 'use-debounce';
import dayjs from 'dayjs';
import ColorButton from '../../components/common/ColorButton';
import { BLUE_COLOR } from '../../constance/color';

export default function InterfaceAXBOMTransactionView() {
  const { t } = useTranslation();
  const tableRef = React.useRef();
  const [target, setTarget] = React.useState(null);
  const [form] = Form.useForm();
  const date = Form.useWatch('date', form)
  const searchText = Form.useWatch("search", form)
  const [debouncedText] = useDebounce(searchText, 500);
  const formattedDate = date ? dayjs(date).format(DATE_FORMAT) : null;

  const handleDoInterfaceAX = async (id) => {
    if (!tableRef.current) {
      return;
    }
    try {
      const response = await POST(`${URL_INTERFACE_AX.BOM_TRANSACTION}${id}/do_interface/`);
      tableRef.current.fetch();
      Toast.success(t('success'));
    } catch (error) {
      tableRef.current.setErrorMessages(error?.errorMessages || [t('error')]);
    } finally {
    }
  };

  React.useEffect(() => {
    if (tableRef.current || debouncedText) {
      tableRef.current.fetch();
    }
  }, [date, debouncedText])

  
  const columns = React.useMemo(() => [
    {
      title: t('date'),
      dataIndex: 'date',
      render: (text) => new Date(text).toLocaleString('en-GB')
    },
    {
      title: t('bom_transactions.order_no'),
      dataIndex: 'order_no',
    },
    {
      title: t('bom_transactions.description'),
      dataIndex: 'description',
      render: (text) => (
        <Popover
          trigger="hover"
          inverted
        >
          <div>{ellipsisString(text)}</div>
        </Popover>
      ),
    },
    {
      title: () => null,
      dataIndex: 'id',
      render: (__, original) => {
        const target = _.get(original, 'id', null);
        const progressing = _.get(original, 'interface_progressing', false);
        return (
          <Space>
            <ColorButton
              variant="outlined"
              color='primary'
              override={BLUE_COLOR}
              disabled={progressing}
              onClick={() => !progressing && handleDoInterfaceAX(target)}
            >
              {progressing ? t('progressing') : t('do_interface_ax')}
            </ColorButton>
            <ColorButton
              variant="outlined"
              color='primary'
              override={BLUE_COLOR}
              icon={<FileTextFilled />}
              onClick={() => setTarget(target)}
            />
          </Space>
        );
      },
    },
  ], [t]);


  return (
    <div>
      <MainHeader activeItem={MENU_INTERFACE_AX} />

      <div style={{ margin: '24px', marginTop: '7em' }}>
        <Title level={2}>
          {t('menus.interface_ax')}: {t('menus.interface_ax_menus.bom')}
        </Title>

        <Form form={form}>
          <Space style={{ width: '100%', textAlign: 'left' }} >
            <Form.Item label={t('searchs.fields.date')} name={'date'}>
              <DatePicker
                format={HUMAN_DATE_FORMAT}
                placeholder={t('searchs.fields.date')}
                style={{ width: 200 }}
              />
            </Form.Item>

            <Form.Item label={t('search')} name={"search"}>
              <Input
                placeholder={t('search')}
                allowClear
              />
            </Form.Item>
          </Space>
        </Form>

        <TSTable
          ref={tableRef}
          url={URL_INTERFACE_AX.BOM_TRANSACTION}
          columns={columns}
          params={{
            date: formattedDate,
            search: searchText
          }}
        />

        <InterfaceAXTransactionModal
          open={target != null}
          onClose={() => setTarget(null)}
          onInterfaceAX={handleDoInterfaceAX}
          url={URL_INTERFACE_AX.BOM_TRANSACTION}
          target={target} />
      </div>
    </div>
  )
}